// extracted by mini-css-extract-plugin
export var container = "_a7-0";
export var fallback = "_a7-5";
export var fallbackIcon = "_a7-6";
export var hidden = "_a7-2";
export var image = "_a7-3";
export var loaded = "_a7-4";
export var placeholder = "_a7-1";